import { Component, EventEmitter, Inject, Input, OnChanges, Optional, Output, SimpleChanges } from '@angular/core';
import { GridModalComponent } from '@app/core/components/grid/grid.decorators';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';
import { ModalService } from '@app/core/services/modal.service';
import { StateDialogContext, TT_STATE_DIALOG } from '@app/modal/state-modal/state-modal.component';
import { CountryItem, LogisticService, MunicipalityItem } from '@app/services/logistic.service';

@GridModalComponent('postplace')
@Component({
    selector: 'tt-postplace',
    templateUrl: './postplace.component.html',
    styleUrls: ['./postplace.component.css'],
})
export class PostplaceComponent implements OnChanges {
    @Input()
    public params?: GetPostplaceParams;

    public get?: PostplaceGet;

    public countries: CountryItem[] = [];

    public municipalities: MunicipalityItem[] = [];

    public saving = false;

    @Output()
    public submit = new EventEmitter<PostplaceGet>();

    constructor(private datatask: DataTaskService, private logistic: LogisticService, private modal: ModalService, @Inject(TT_STATE_DIALOG) @Optional() stateDialog?: StateDialogContext) {
        this.initFromDialog(stateDialog);
    }

    public async save() {
        if (!this.get) return;

        try {
            this.saving = true;

            const { errorcode, errormessage } = await this.savePostplace(this.get);

            if ('' + errorcode !== '0') {
                this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: errormessage });
            } else {
                this.submit.emit(this.get);
            }
        } catch (error) {
            console.error(error);
        } finally {
            this.saving = false;
        }
    }

    private async loadGet() {
        if (!!this.params && 'postplace_id' in this.params) {
            this.get = await this.getPostplace(this.params);
        }
    }

    private async loadCountries() {
        this.countries = await this.logistic.getCountries();
    }

    public async loadMunicipalities() {
        if (!!this.get) {
            this.municipalities = await this.logistic.getMunicipalities(this.get);
        }
    }

    private async savePostplace(params: PostplaceGet): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(2209, params))[0];
    }

    private async getPostplace(params: GetPostplaceParams): Promise<PostplaceGet> {
        return (await this.datatask.Post(2208, params))[0];
    }

    private async init() {
        this.loadCountries();
        await this.loadGet();
        this.loadMunicipalities();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['params']) {
            this.init();
        }
    }

    private async initFromDialog(stateDialog?: StateDialogContext) {
        if (!!stateDialog?.params && 'postplace_id' in stateDialog.params) {
            this.params = stateDialog.params as unknown as GetPostplaceParams;
            stateDialog.setSize({ width: '35rem' });
            await this.init();
            stateDialog.setHeading(this.get?.heading ?? '');
            this.submit.subscribe({ next: () => stateDialog.close(this.get) });
        }
    }
}

export interface GetPostplaceParams {
    postplace_id: string;
}

export interface PostplaceGet {
    heading: string;
    postplace_id: string;
    postplace_name: string;
    comunity_id: string;
    country_id: string;
}
